<div class="dialog-form">
  <div class="invoice-result-container">
    <section class="container-fluid no-breadcrumbs">

      <p-fieldset class="summary-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-chart-bar" style="margin-right: 8px;"></i>
            Resumo da Geração
          </h3>
        </p-header>
        <div class="summary-cards">
          <div class="summary-card">
            <div class="summary-icon orders">
              <i class="pi pi-shopping-cart"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Total de Pedidos</div>
              <div class="summary-value">{{ totalOrders }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon groups">
              <i class="pi pi-sitemap"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Grupos Criados</div>
              <div class="summary-value">{{ totalGroups }}</div>
            </div>
          </div>
          <div class="summary-card">
            <div class="summary-icon allotment">
              <i class="pi pi-hashtag"></i>
            </div>
            <div class="summary-content">
              <div class="summary-label">Allotment</div>
              <div class="summary-value">{{ allotment }}</div>
            </div>
          </div>
        </div>
      </p-fieldset>

      <p-fieldset *ngIf="groups.length > 0" class="groups-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-sitemap" style="margin-right: 8px;"></i>
            Grupos de Processamento
          </h3>
        </p-header>

        <div *ngIf="!showGroupsAsList" class="groups-container">
          <div class="group-card" *ngFor="let group of groups; let i = index" (click)="openGroupDetail(group)" style="cursor: pointer;">
            <div class="group-header">
              <div class="group-header-left">
                <span class="group-number">Grupo {{ i + 1 }}</span>
                <span class="header-status" [ngClass]="'status-' + getSuccessStatus(group, i)">
                  <i [class]="getSuccessIcon(group, i)"></i>
                </span>
              </div>
              <i class="pi pi-external-link" style="color: #667eea;"></i>
            </div>
            <div class="group-content">
              <div class="group-item">
                <i class="pi pi-shopping-cart group-icon"></i>
                <div class="group-item-content">
                  <div class="group-item-label">Pedidos</div>
                  <div class="group-item-value">
                    <span class="badge" *ngFor="let orderId of group.orderIds; let i = index"
                          [title]="'ID: ' + orderId">
                      {{ (group.orderNumbers && group.orderNumbers[i]) ? group.orderNumbers[i] : orderId }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="group-item">
                <i class="pi pi-users group-icon"></i>
                <div class="group-item-content">
                  <div class="group-item-label">Clientes</div>
                  <div class="group-item-value">
                    <span class="badge" *ngFor="let customerId of group.customerIds; let i = index"
                          [title]="'ID: ' + customerId">
                      {{ (group.customerNames && group.customerNames[i]) ? group.customerNames[i] : customerId }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="group-item" *ngIf="group.sqsMessageId">
                <i class="pi pi-tag group-icon"></i>
                <div class="group-item-content">
                  <div class="group-item-label">SQS Message ID</div>
                  <div class="group-item-value">
                    <span class="badge sqs-message-badge">{{ group.sqsMessageId }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Visualização em Lista (mais de 10 grupos) -->
        <div *ngIf="showGroupsAsList" class="groups-list-container">
          <p-table [value]="groups" [paginator]="true" [rows]="20" [rowsPerPageOptions]="[10, 20, 50, 100]"
                   styleClass="p-datatable-sm groups-table" [scrollable]="true" scrollHeight="400px">
            <ng-template pTemplate="header">
              <tr>
                <th style="width: 80px">Grupo</th>
                <th>Pedidos</th>
                <th>Clientes</th>
                <th style="width: 100px">Qtd Pedidos</th>
                <th style="width: 100px">Qtd Clientes</th>
                <th style="width: 120px">SQS Message ID</th>
                <th style="width: 120px">Status</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-group let-i="rowIndex">
              <tr (click)="openGroupDetail(group)" style="cursor: pointer;">
                <td>
                  <span class="group-number-badge">{{ i + 1 }}</span>
                </td>
                <td>
                  <span class="id-list" [title]="'IDs: ' + formatIds(group.orderIds)">
                    {{ group.orderNumbers ? formatIds(group.orderNumbers) : formatIds(group.orderIds) }}
                  </span>
                </td>
                <td>
                  <span class="id-list" [title]="'IDs: ' + formatIds(group.customerIds)">
                    {{ group.customerNames ? group.customerNames.join(', ') : formatIds(group.customerIds) }}
                  </span>
                </td>
                <td class="text-center">
                  <span class="count-badge">{{ group.orderIds.length }}</span>
                </td>
                <td class="text-center">
                  <span class="count-badge">{{ group.customerIds.length }}</span>
                </td>
                <td class="text-center">
                  <span class="sqs-message-badge" *ngIf="group.sqsMessageId">{{ group.sqsMessageId }}</span>
                  <span *ngIf="!group.sqsMessageId" class="text-muted">N/A</span>
                </td>
                <td class="text-center">
                  <span class="badge status-badge" [ngClass]="'status-' + getSuccessStatus(group, i)">
                    <i [class]="getSuccessIcon(group, i)"></i>
                    {{ getSuccessLabel(group, i) }}
                  </span>
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </p-fieldset>

      <p-fieldset class="log-fieldset">
        <p-header>
          <h3 class="article-title">
            <i class="pi pi-list" style="margin-right: 8px;"></i>
            Log de Execução ({{ logActions.length }} ações)
          </h3>
        </p-header>
        <div class="log-container">
          <div class="log-timeline">
            <div class="log-item"
                 *ngFor="let action of logActions; let i = index"
                 [ngClass]="getActionClass(action.description)">
              <div class="log-marker">
                <i [class]="getActionIcon(action.description)"></i>
              </div>
              <div class="log-content">
                <div class="log-header">
                  <span class="log-description">{{ action.description }}</span>
                  <span class="log-time" *ngIf="i > 0">+{{ getTimeDifference(i) }}</span>
                </div>
                <div class="log-datetime">
                  <i class="pi pi-clock"></i>
                  {{ formatDateTime(action.datetime) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </p-fieldset>

    </section>
  </div>
</div>
